import {LiveShoppingSection} from '../../../grpc_client/grips/protos/pages/v1/live_shopping';
import {ExtendedLiveShoppingSection} from '../types';

export const sectionMapper = (sections: LiveShoppingSection[]) => {
  return sections.reduce((acc, section) => {
    if (section.events.length) {
      const extendedSection: ExtendedLiveShoppingSection = {
        ...section,
        state: section.events[0].state,
      };
      return [...acc, extendedSection];
    }

    return acc;
  }, [] as ExtendedLiveShoppingSection[]);
};
